import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React from "react";
import { Button, Modal } from "react-bootstrap";

import FASvgIcon from "../FASvgIcon";

type Props = {
	showModal: boolean;
	title: string;
	message: JSX.Element;
	onYesBtnClick: () => void;
	iconColorClass?: string;
	icon?: IconProp;
	onYesBtnText?: string;
	isProcessing?: boolean;
};

const AlertModal: React.FC<Props> = (props: Props) => {
	const {
		showModal,
		iconColorClass = "text-primary",
		icon = faCircleCheck,
		title,
		message,
		onYesBtnClick,
		onYesBtnText = "Yes",
		isProcessing = false
	} = props;

	return (
		<Modal show={showModal} centered backdrop="static" className="alert-modal">
			<Modal.Body className="text-center">
				<div className={classNames("icon-wrap", iconColorClass)}>
					<FASvgIcon icon={icon} />
				</div>
				<h1 className="fw-bold">{title}</h1>
				<>{message}</>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="secondary"
					onClick={onYesBtnClick}
					disabled={isProcessing}
					className="btn-w-250"
				>
					{onYesBtnText}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default AlertModal;
